export const getClientDomain = () => {
  if (process.env.REACT_APP_ENV === "prod") {
    return window.location.hostname;
  } else if (
    process.env.REACT_APP_ENV === "dev" ||
    process.env.REACT_APP_ENV === "test"
  ) {
    return "www.test.medinav.ca";
  } else {
    throw new Error("Invalid environment configuration");
  }
};
